import { useSyncExternalStore } from 'react';
import { subscribePolyAttempts, polyAttemptCount, clearPolyAttempts, exportPolyAttempts } from '../../lib/infra/polyAttemptJournal';

export function PolyAttemptDiagnosticsPanel() {
  const count = useSyncExternalStore(subscribePolyAttempts, polyAttemptCount);
  const download = () => {
    const url = URL.createObjectURL(new Blob([exportPolyAttempts()], { type: 'application/json' }));
    const link = document.createElement('a'); link.href = url; link.download = 'g1-poly-attempts.json'; link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1_000);
  };
  return <div className="border-border mt-4 border-t pt-4">
    <h3 className="text-sm font-medium">Polymarket attempt diagnostics</h3>
    <p className="text-muted-foreground mt-2 text-xs leading-relaxed">
      Recent submit checks and request outcomes are recorded automatically, including local blocks.
      Records contain market IDs and times, not prices, quantities or credentials, and are sent to this deployment when available.
      This tab keeps up to 96 records for 24 hours, including across reloads. Signing out or changing account clears them.
      These diagnostics do not prove an order was accepted. Clearing removes this tab’s copy only.
    </p>
    <p className="text-muted-foreground mt-2 text-xs">{count} records in this tab</p>
    <div className="mt-2 flex flex-wrap gap-2">
      <button className="bg-secondary rounded px-3 py-2 text-xs disabled:opacity-50" disabled={!count} onClick={download}>Download attempt diagnostics</button>
      <button className="bg-secondary rounded px-3 py-2 text-xs disabled:opacity-50" disabled={!count} onClick={clearPolyAttempts}>Clear local attempt diagnostics</button>
    </div>
  </div>;
}
